export default "__VITE_ASSET__60d324f6__"